export const ActionTypes = {
  LOADING: "UPDATE_PASSWORD_LOADING",
  ERROR: "UPDATE_PASSWORD_ERROR",
  SUCCESS: "UPDATE_PASSWORD_SUCCESS",
};
